import { withRouter } from 'react-router-dom';
import BackLink from './BackLink';

const BackLinkWithRouter = withRouter(BackLink);
BackLinkWithRouter.displayName = 'BackLinkWithRouter';

export default BackLinkWithRouter;
